export type GeoReadinessFaq = {
  q: string;
  a: string;
};

export const GEO_READINESS_FAQS: Record<"en" | "es", GeoReadinessFaq[]> = {
  en: [
    {
      q: "Does this guarantee citations in ChatGPT, Google AI Overviews or Perplexity?",
      a: "No. No audit can control which source a platform selects. The delivery identifies evidence, signals and gaps that the team can actually work on.",
    },
    {
      q: "Is this the same as technical SEO?",
      a: "No. It can include technical findings, but also evaluates entity evidence, independent sources, editorial clarity and the questions for which the brand should be supportable.",
    },
    {
      q: "Is implementation included?",
      a: "No. This is a diagnostic. When the roadmap justifies execution, Shugert can prepare a separate fixed-price scope.",
    },
    {
      q: "Do you need Shopify or Analytics access?",
      a: "Starter relies primarily on public signals. A deeper review may request additional context, but we never request access before explaining why it is necessary.",
    },
  ],
  es: [
    {
      q: "¿Garantiza citas en ChatGPT, Google AI Overviews o Perplexity?",
      a: "No. Ninguna auditoría puede controlar qué fuente elige una plataforma. La entrega identifica señales, evidencia y gaps que sí puede trabajar el equipo.",
    },
    {
      q: "¿Es lo mismo que SEO técnico?",
      a: "No. Puede incluir hallazgos técnicos, pero también revisa entidad, fuentes externas, claridad editorial y consultas donde la marca debería poder ser respaldada.",
    },
    {
      q: "¿Incluye implementación?",
      a: "No. El producto es un diagnóstico. Cuando el roadmap justifica ejecución, Shugert puede preparar un scope separado y de precio fijo.",
    },
    {
      q: "¿Necesitan acceso a Shopify o Analytics?",
      a: "Starter se basa principalmente en señales públicas. En revisiones más profundas podemos solicitar contexto adicional, pero nunca pedimos acceso antes de explicar por qué se necesita.",
    },
  ],
};
